import SelectCurrenciesMulti from './select-currencies-multi';
export default SelectCurrenciesMulti;
